// Paying people and cash handed in were first ticked on 29 Oct 2026, when Close out the day arrived (0095). A day before
// it was settled the old way, so it never shows as still to pay or cash to come: Dropby's history has hundreds of day
// totals with pay and no tick (Money's Day totals, the bottom of a day in the Diary).
export const CLOSE_OUT_FROM = '2026-10-29'
